import { nanoid } from "nanoid";
import { sendConversionsEvent } from "api/conversions";

import { COOKIES, UTSLocaleToCountryCode } from "constants/enum";
import { getAppMode } from "utils/getAppMode";
import { getCookiesValueByName } from "utils/cookie";

import { AnaliticData } from "./types";
import { FacebookEvents } from "./events";

export const sendFacebookEvent = (
    eventName: string,
    customData?: { [key: string]: string },
    eventData?: { eventID: string },
    isCustom = false
) => {
    const { isDevMode } = getAppMode();

    if (!window.fbq || isDevMode) {
        return;
    }

    // TODO: [AD-2301] marketing-cookie gate removed; restore IS_MARKETING_COOKIE_ACTIVE check if required.

    if (isCustom) {
        window.fbq("trackCustom", eventName, customData, eventData);
        return;
    }

    window.fbq("track", eventName, customData, eventData);
};

const sendPostFacebookLeadEvent = async ({
    eventID2,
    eventID3,
    leadEventName,
    cityTitle,
    firstName,
    lastName,
    email,
    phone,
    locale,
}: {
    eventID1: string;
    eventID2: string;
    eventID3: string;
    leadEventName: FacebookEvents;
} & AnaliticData) => {
    const eventData = {
        eventSourceUrl: window?.location?.href,
        userData: {
            country: UTSLocaleToCountryCode[locale],
            city: cityTitle,
            firstName,
            lastName,
            email,
            phone,
            fbp: decodeURIComponent(getCookiesValueByName(COOKIES.FBP)),
            fbc: decodeURIComponent(getCookiesValueByName(COOKIES.FBC)),
            clientUserAgent: window?.navigator?.userAgent,
        },
    };

    await sendConversionsEvent({
        ...eventData,
        eventName: leadEventName,
        eventId: eventID2,
    });
    await sendConversionsEvent({
        ...eventData,
        eventName: FacebookEvents.FORM_SUBMIT_FACEBOOK_FORM_VIEW_CONTENT,
        eventId: eventID3,
    });
};

export const sendAllFacebookAnalitic = async ({
    cityTitle,
    firstName,
    lastName,
    email,
    phone,
    locale,
    leadEventName = FacebookEvents.FORM_SUBMIT_FACEBOOK_LEAD_EVENT,
}: AnaliticData & { leadEventName?: FacebookEvents }) => {
    const eventID1 = nanoid();
    const eventID2 = nanoid();
    const eventID3 = nanoid();
    const { isDevMode } = getAppMode();

    if (isDevMode) return;

    // TODO: [AD-2301] marketing-cookie gate removed; restore before sendPostFacebookLeadEvent if required.

    await sendPostFacebookLeadEvent({
        eventID1,
        eventID2,
        eventID3,
        leadEventName,
        cityTitle,
        firstName,
        lastName,
        email,
        phone,
        locale,
    });

    const eventData = {
        country: UTSLocaleToCountryCode[locale],
        ...(cityTitle && { city: cityTitle }),
        first_name: firstName,
        last_name: lastName,
        email,
        phone_number: phone,
    };

    sendFacebookEvent(
        leadEventName,
        eventData,
        {
            eventID: eventID2,
        },
        true
    );
    sendFacebookEvent(
        FacebookEvents.FORM_SUBMIT_FACEBOOK_FORM_VIEW_CONTENT,
        eventData,
        {
            eventID: eventID3,
        }
    );
};
